/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred Quality Score Converter — Toolverse`)
};

const es_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Puntuación de Calidad Phred — Toolverse`)
};

const de_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred-Qualitätswert-Konverter — Toolverse`)
};

const nl_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred-kwaliteitsscoreconverter — Toolverse`)
};

const fr_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de score de qualité Phred — Toolverse`)
};

const it_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore del punteggio di qualità Phred — Toolverse`)
};

const pt_br2_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Escore de Qualidade Phred — Toolverse`)
};

const pt_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Pontuação de Qualidade Phred — Toolverse`)
};

const ja_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコア変換ツール — Toolverse`)
};

const zh_phred_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred 质量分数转换器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_meta_title", locale)
	if (locale === "en") return en_phred_meta_title(inputs)
	if (locale === "es") return es_phred_meta_title(inputs)
	if (locale === "de") return de_phred_meta_title(inputs)
	if (locale === "nl") return nl_phred_meta_title(inputs)
	if (locale === "fr") return fr_phred_meta_title(inputs)
	if (locale === "it") return it_phred_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_phred_meta_title(inputs)
	if (locale === "pt") return pt_phred_meta_title(inputs)
	if (locale === "ja") return ja_phred_meta_title(inputs)
	return zh_phred_meta_title(inputs)
};